import React, { useEffect, useState } from 'react'
import { LogoutOutlined } from '@ant-design/icons'
import { Avatar, Menu, Modal } from 'antd'
import HeaderDropdown from '../HeaderDropdown'
import { getLoginOut } from '@/service/index'
import { setCookie } from '@/utils/cookie'
// @ts-ignore
import { IUseInfoData } from './../index.d'
import styles from './index.module.less'

export interface GlobalHeaderRightProps {
  useInfo: IUseInfoData
}

const loginOut = () => {
  getLoginOut().then(() => {
    window.location.href = location.origin + `/webapp/login?redirect=${location.pathname + location.search}`
  })
}
/**
 * 退出登录，并且将当前的 url 保存
 */
const logoutconfirm = () => {
  setCookie('token', '', 0)
  localStorage.removeItem('menu')
  Modal.confirm({
    title: '确定退出登录吗?',
    content: '',
    okText: '确定',
    okType: 'primary',
    cancelText: '取消',
    onOk: () => {
      loginOut() // 确认按钮的回调方法，在下面
    },
    onCancel () {
      console.log('Cancel')
    }
  })
}

const AvatarDropdown = (props: GlobalHeaderRightProps): JSX.Element => {
  const [welcomeMsg, setWelcomeMsg] = useState<string>('')

  const updateWelcomeMsg = () => {
    const date = new Date().getHours()
    if (date < 12) {
      setWelcomeMsg('上午好')
    } else if (date >= 12 && date <= 19) {
      setWelcomeMsg('下午好')
    } else {
      setWelcomeMsg('晚上好')
    }
  }
  // @ts-ignore
  const onMenuClick = ({ key }) => {
    console.warn(key)
    if (key === 'logout') {
      logoutconfirm()
    }
  }

  useEffect(() => {
    updateWelcomeMsg()
    const interval = setInterval(() => {
      updateWelcomeMsg()
    }, 1000 * 60 * 10)
    return () => {
      clearInterval(interval)
    }
  }, [])

  const menuHeaderDropdown = (
    <Menu className={styles.menu} selectedKeys={[]} onClick={onMenuClick}>
      <Menu.Item key="logout">
        <LogoutOutlined />
        退出登录
      </Menu.Item>
    </Menu>
  )
  return (
    <HeaderDropdown overlay={menuHeaderDropdown}>
      <span className={`${styles.action} ${styles.account}`}>
        <Avatar size="small" className={styles.avatar} src={'https://pic1.58cdn.com.cn/nowater/fangfe/n_v2bf8df92f6ed54b8cb6ccacd446299724.png'} alt="avatar" />
        <span className={`${styles.name} anticon`}>{welcomeMsg}，{props?.useInfo?.userRealName || ''}</span>
      </span>
    </HeaderDropdown>
  )
}

export default AvatarDropdown
